
const createScript = (url: any) => {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = url;
  script.async = true;
  document.body.appendChild(script);
};
export default createScript;
